/* global google */

import * as I from "immutable";
import moment from "moment-timezone";

import {MAX_NUMBER_OF_WAYPOINTS} from "config/constants";
import {addressArrow, getRouteWaypoints} from "v1/googleUtils";

const splitScheduleIntoChunks = (list, number) => {
  const numberOfChunks = Math.ceil(list.size / number);
  return I.Range(0, numberOfChunks)
    .map(idx => {
      const start = idx * (number - 1);
      return list.slice(start, start + number);
    });
};

/**
 * Generate Google API Driving Time requests for V2 destinations List.
 */
export const generateDrivingTimeRequests = (destinations) => {
  const filtered = destinations.filter(addressArrow);
  if (filtered.size < 2) {
    return I.List();
  }
  return splitScheduleIntoChunks(filtered, MAX_NUMBER_OF_WAYPOINTS)
    .map(chunk => ({
      origin: chunk.first().address,
      destination: chunk.last().address,
      waypoints: getRouteWaypoints(chunk).toArray(),
      travelMode: google.maps.TravelMode.DRIVING,
    }));
};


export const updateDestinationsTimes = (responses, destinations, startTime, appData) => {
  if (destinations.filter(addressArrow).size < 2) {
    return destinations;
  }

  const legs = responses.reduce((result, chunkResponse) =>
    result.concat(chunkResponse.routes[0].legs),
    []
  );
  const durations = legs.map((item) => {
    const duration = moment.duration(item.duration.value, "seconds");
    return moment.duration(Math.ceil(duration.asMinutes()), "minutes");
  });

  let addressFound = false;
  let durationIdx = 0;
  let prevTime;

  return destinations.map((item, idx) => {
    if (!idx) {
      item = item.set("estStartTime", startTime);
    } else {
      if (item.address && addressFound) {
        item = item.set(
          "estStartTime",
          prevTime.clone().add(durations[durationIdx]));
        durationIdx++;
      } else {
        let drivingTime = moment.duration(0);
        if (appData.destinationTypePhysical.get(item.type)) {
          drivingTime = moment.duration(appData.defaultDrivingTimeSec, "seconds");
        }
        item = item.set("estStartTime", prevTime.clone().add(drivingTime));
      }
    }

    if (item.address) {
      addressFound = true;
    }

    item = item.set(
      "estEndTime",
      item.estStartTime.clone().add(item.duration)
    );
    prevTime = item.estEndTime;

    return item;
  });
};

export default {
  generateDrivingTimeRequests,
  updateDestinationsTimes,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/googleUtils.js
 **/